/**
 * Insert into a Map with a hard size ceiling, evicting the oldest entry
 * (insertion order — JS Map preserves it) when full. FIFO, not LRU: callers
 * here cache values that change at most once per session, so promoting on read
 * would add cost for no benefit.
 *
 * Updating an existing key never evicts — it's not growth.
 */
export function boundedSet<K, V>(map: Map<K, V>, key: K, value: V, max: number): void {
  if (map.size >= max && !map.has(key)) {
    const oldest = map.keys().next().value;
    if (oldest !== undefined) map.delete(oldest);
  }
  map.set(key, value);
}
